import * as React from 'react';
import MemberInvoices from './member-invoices';
import { useMemberInvoiceData } from './useMemberInvoiceData';
import { useShowOrganization } from 'hooks/GraphQL';
import LoadingTableAndKeyInsights from 'components/common/loading-table-key-insights';

type Props = {
  orgId: number;
  memberId: number;
};

export default function MemberInvoicesContainer({ orgId, memberId }: Props) {
  const [orgData] = useShowOrganization(orgId);
  const org = orgData?.showOrganization;
  const timeZone = org?.timezoneIana;

  const { invoicesData, invoicesKeyInsights, loading } = useMemberInvoiceData({
    orgId,
    memberId,
    timeZone,
  });
  if (loading) {
    return <LoadingTableAndKeyInsights />
  }
  return (
    <MemberInvoices
      invoicesData={invoicesData}
      invoicesKeyInsights={invoicesKeyInsights}
    />
  );
}
